import i18next from 'i18next';
import { RegisterOptions } from 'react-hook-form';

export const formRules: RegisterOptions = {
  required: i18next.t('common:required_field').toString(),
};

export const maxLengthRules = (maxLength = 100): RegisterOptions => {
  return {
    maxLength: {
      value: maxLength,
      message: i18next.t('common:maximum_number_characters', { maxLength }),
    },
  };
};
